import { getUXState } from '../reducers';
import { createSelector } from '@ngrx/store';

export const getActiveTheme = createSelector(getUXState, state => state.theme.activeTheme);
